import React from 'react'
import { LI, UL } from '../../../../../AbstractElements'

export default function DotText() {
    return (
        <UL className="dot-group pb-3 pt-0 simple-list flex-row">
            <LI />
            <LI />
            <LI />
        </UL>
    )
}
